export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://127.0.0.1:5850/api';
export const SOCKET_URL = SERVER_URL.replace(/^http/, 'ws').replace(/\/api/, '');
export const SOCKET_PATH = '/socket.io';
